import { useLocale } from "../../../i18n/LocaleContext";
import type { VpnDetailItem } from "../../../types";
import BooleanField from "./BooleanField";
import ComplexBooleanField from "./ComplexBooleanField";
import LabeledField from "./LabeledField";

interface DynamicFieldProps {
  item: VpnDetailItem;
}

function DynamicField({ item }: DynamicFieldProps) {
  const { t } = useLocale();

  if (item.type === "complex_boolean_field") {
    return (
      <ComplexBooleanField
        label={item.label}
        fieldKey={item.fieldKey}
        isPositive={item.isPositive}
        hintText={item.hintText}
        yesText={item.yesText ?? t("common.present")}
        noText={item.noText ?? t("common.absent")}
      />
    );
  }

  if (item.type === "boolean_field") {
    return (
      <BooleanField
        label={item.label}
        value={item.value}
        yesText={item.yesText ?? t("common.present")}
        noText={item.noText ?? t("common.absent")}
      />
    );
  }

  if (item.type === "labeled_field") {
    return <LabeledField label={item.label}>{item.value}</LabeledField>;
  }

  return null;
}

export default DynamicField;
